import React from 'react';
import { X, Cloud, Key, Server } from 'lucide-react';
interface AddAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function AddAccountModal({
  isOpen,
  onClose
}: AddAccountModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-id="element-36">
      <div className="w-full max-w-[500px] bg-astro-card border border-astro-border rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-37">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-astro-border" data-id="element-38">
          <h2 className="text-lg font-bold text-white" data-id="element-39">Connect New Account</h2>
          <button onClick={onClose} className="text-astro-text-secondary hover:text-white transition-colors p-1" data-id="element-40">

            <X size={20} data-id="element-41" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6" data-id="element-42">
          {/* Provider Selection */}
          <div data-id="element-43">
            <label className="block text-sm font-medium text-white mb-3 flex items-center gap-2" data-id="element-44">
              <Cloud size={16} className="text-astro-green" data-id="element-45" />
              Cloud Provider
            </label>
            <div className="grid grid-cols-3 gap-3" data-id="element-46">
              {[{
              name: 'AWS',
              active: true
            }, {
              name: 'Azure',
              active: false
            }, {
              name: 'GCP',
              active: false
            }].map(provider => <button key={provider.name} className={`px-3 py-3 text-sm font-medium rounded border transition-all flex flex-col items-center gap-2 ${provider.active ? 'bg-astro-green/10 border-astro-green text-white' : 'bg-[#0a0e14] border-astro-border text-astro-text-secondary hover:text-white hover:border-white/20'}`} data-id="element-47">

                  <span className="font-bold" data-id="element-48">{provider.name}</span>
                </button>)}
            </div>
          </div>

          {/* Account Details */}
          <div className="space-y-4" data-id="element-49">
            <div data-id="element-50">
              <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-51">
                Account Name
              </label>
              <input type="text" placeholder="e.g. Production AWS" className="w-full bg-[#0a0e14] border border-astro-border rounded px-3 py-2 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" data-id="element-52" />

            </div>

            <div data-id="element-53">
              <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-54">
                Account ID / Subscription ID
              </label>
              <div className="relative" data-id="element-55">
                <Server size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-astro-text-secondary" data-id="element-56" />

                <input type="text" placeholder="1234-5678-9012" className="w-full bg-[#0a0e14] border border-astro-border rounded pl-9 pr-3 py-2 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" data-id="element-57" />

              </div>
            </div>

            <div data-id="element-58">
              <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-59">
                API Key / Secret
              </label>
              <div className="relative" data-id="element-60">
                <Key size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-astro-text-secondary" data-id="element-61" />

                <input type="password" placeholder="••••••••••••••••••••••••" className="w-full bg-[#0a0e14] border border-astro-border rounded pl-9 pr-3 py-2 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" data-id="element-62" />

              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="flex justify-end gap-3 pt-2" data-id="element-63">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-astro-text-secondary border border-astro-border rounded hover:text-white hover:border-white/30 transition-colors" data-id="element-64">

              Cancel
            </button>
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-white bg-astro-green-dark hover:bg-astro-green rounded transition-colors shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-65">

              Connect Account
            </button>
          </div>
        </div>
      </div>
    </div>;
}